(() => {
  const script = document.currentScript;
  const notice = script && document.getElementById(script.dataset.amcHoldId);
  const host = notice && notice.parentElement;
  const roots = host ? host.querySelectorAll('[data-amc-invalid-configurator="52289694990638"]') : [];
  const root = Array.from(roots).find((candidate) => candidate.querySelector('#bAdd'));
  if (!notice) return;

  const stopConfiguredCheckout = (event) => {
    const eventTarget = event.submitter || event.target;
    const trigger = eventTarget.closest && eventTarget.closest('#bAdd');
    if (!trigger || !root || !root.contains(trigger)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    notice.focus({ preventScroll: false });
  };

  if (!root) {
    notice.querySelector('strong').textContent = 'Configured checkout unavailable';
    return;
  }

  root.addEventListener('click', stopConfiguredCheckout, true);
  root.addEventListener('submit', stopConfiguredCheckout, true);

  const secure = () => {
    const button = root.querySelector('#bAdd');
    if (!button) return false;
    button.dataset.amcHold = 'true';
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.setAttribute('aria-describedby', notice.id);
    button.textContent = 'Configured checkout unavailable';
    return true;
  };

  if (!secure()) {
    const observer = new MutationObserver(() => {
      if (secure()) observer.disconnect();
    });
    observer.observe(root, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 5000);
  }

  const selectIds = ['bLoc', 'bDoor', 'bHinge', 'bHandle', 'bPlate', 'bRef', 'bFloor', 'bRamp', 'bLed'];
  const labelNames = {
    bLoc: 'Door Location', bDoor: 'Door Size', bHinge: 'Door Hinge', bHandle: 'Lockable Door Handle',
    bPlate: 'Diamond Plate', bRef: 'Refrigeration System', bFloor: 'Insulated Floor',
    bRamp: 'Ramp', bLed: 'LED Lighting Package'
  };
  selectIds.forEach((id, index) => {
    const select = root.querySelector(`#${id}`);
    if (!select) return;
    let label = null;
    let sibling = select.previousElementSibling;
    while (sibling && !label) {
      if (sibling.matches('label')) label = sibling;
      else if (sibling.matches('select, input, button, textarea')) break;
      sibling = sibling.previousElementSibling;
    }
    if (!label && select.parentElement) label = select.parentElement.querySelector(':scope > label');
    if (!label) {
      label = Array.from(root.querySelectorAll('label')).find((candidate) =>
        candidate.textContent.replace(/\s+/g, ' ').trim().startsWith(labelNames[id])
      );
    }
    if (!label) return;
    const labelId = `${notice.id}-${id}-label-${index}`;
    label.id = labelId;
    label.htmlFor = id;
    select.setAttribute('aria-labelledby', labelId);
    label.addEventListener('click', (event) => {
      event.preventDefault();
      select.focus({ preventScroll: true });
    });
  });

  root.querySelectorAll('p, small, div').forEach((element) => {
    const text = element.textContent.replace(/\s+/g, ' ').trim();
    if (text.startsWith('Click Add This Build To Cart') && text.includes('straight to your cart')) {
      element.textContent = 'Configured options require review. Request an itemized configuration quote below.';
      element.classList.add('amc-configurator-review-copy');
    }
  });

  const total = root.querySelector('#bTotal');
  const grand = root.querySelector('#bGrand');
  const message = root.querySelector('#bMsg');
  const live = document.createElement('div');
  live.id = `${notice.id}-status`;
  live.className = 'visually-hidden';
  live.setAttribute('role', 'status');
  live.setAttribute('aria-live', 'polite');
  live.setAttribute('aria-atomic', 'true');
  root.appendChild(live);

  if (message) {
    message.removeAttribute('role');
    message.removeAttribute('aria-live');
    message.removeAttribute('aria-atomic');
  }

  const summary = Array.from(root.querySelectorAll('div, p, span')).find((element) =>
    element.childElementCount === 0 && element.textContent.replace(/\s+/g, ' ').trim() === 'Standard configuration — make selections above to customize.'
  );
  if (summary) {
    summary.dataset.amcConfigSummary = 'true';
    summary.textContent = 'Base-unit planning estimate — selected options require review.';
  }

  let announceTimer;
  let lastAnnouncement = '';
  const updateAccessibleState = () => {
    if (typeof root.closest('product-info')?.amcAddConfiguredBuild === 'function') return;
    const configured = selectIds.some((id) => {
      const select = root.querySelector(`#${id}`);
      return select && !select.closest('[hidden]') && select.selectedIndex > 0;
    });
    if (summary) {
      summary.textContent = configured
        ? 'Planning estimate updated — request an itemized configuration review.'
        : 'Base-unit planning estimate — selected options require review.';
    }
    window.clearTimeout(announceTimer);
    announceTimer = window.setTimeout(() => {
      if (typeof root.closest('product-info')?.amcAddConfiguredBuild === 'function') return;
      const grandText = grand && grand.textContent.trim();
      const totalText = total && total.textContent.trim();
      const announcement = `Planning estimate updated: ${grandText || 'total unavailable'}. Selected options ${totalText || 'unavailable'}. Configured options require review.`;
      if (announcement === lastAnnouncement) return;
      lastAnnouncement = announcement;
      live.textContent = announcement;
      if (message) message.textContent = announcement;
    }, 350);
  };

  root.addEventListener('change', () => window.requestAnimationFrame(updateAccessibleState));
  const reset = root.querySelector('#bReset');
  if (reset) reset.addEventListener('click', () => window.requestAnimationFrame(updateAccessibleState));
})();
